export const environment = {
    production: true,
    urlPortalestudante: "https://tjbaacademico.tjba.jus.br/",
    url: "https://tjbaacademicows.tjba.jus.br/",
    packageFile: "./../../../../package.json",
    VERSION: require("../../package.json").version,
    gridPageSize: 10,
    gridPageIndex: 0,
    envName: "",
    urlSessaoJulgamentoAPI: "https://www.tjba.jus.br/sessaojulgamento2gws/",
};
